import { FEATURE_NAMES, FEATURES } from './feature-names';

export const PAYMENT_GATEWAYS = {
  IPG: 0,
  DPG: 1,
  WALLET: 3,
  CPG: 4,
  // Reverse
  0: 'IPG',
  1: 'DPG',
  3: 'WALLET',
  4: 'CPG',
};

export const GATEWAY_TO_FEATURE_MAP = {
  WALLET: FEATURES[FEATURE_NAMES.PAYMENT_WALLET],
  IPG: FEATURES[FEATURE_NAMES.PAYMENT_IPG],
  DPG: FEATURES[FEATURE_NAMES.PAYMENT_DPG],
};
